import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const OverviewTab = ({ institution }) => {
  return (
    <div className="space-y-6">
      {/* Description */}
      <div className="bg-card border border-border rounded-lg p-6">
        <h3 className="text-lg font-heading font-semibold text-foreground mb-4">
          À propos de l'établissement
        </h3>
        <p className="text-muted-foreground leading-relaxed">
          {institution?.description}
        </p>
      </div>
      {/* Campus Facilities */}
      <div className="bg-card border border-border rounded-lg p-6">
        <h3 className="text-lg font-heading font-semibold text-foreground mb-4">
          Infrastructures du campus
        </h3>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {institution?.facilities?.map((facility, index) => (
            <div key={index} className="flex items-center gap-3 p-3 bg-muted rounded-lg">
              <Icon name={facility?.icon} size={20} className="text-primary" />
              <span className="text-sm font-medium text-foreground">{facility?.name}</span>
            </div>
          ))}
        </div>
      </div>
      {/* Accreditations */}
      <div className="bg-card border border-border rounded-lg p-6">
        <h3 className="text-lg font-heading font-semibold text-foreground mb-4">
          Accréditations et certifications
        </h3>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {institution?.accreditations?.map((accreditation, index) => (
            <div key={index} className="flex items-start gap-3 p-4 border border-border rounded-lg">
              <Icon name="Award" size={20} className="text-accent mt-1" />
              <div>
                <h4 className="font-medium text-foreground">{accreditation?.name}</h4>
                <p className="text-sm text-muted-foreground mt-1">{accreditation?.description}</p>
                <span className="text-xs text-success font-medium">Valide jusqu'en {accreditation?.validUntil}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Photo Gallery */}
      <div className="bg-card border border-border rounded-lg p-6">
        <h3 className="text-lg font-heading font-semibold text-foreground mb-4">
          Galerie photos
        </h3>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {institution?.gallery?.map((photo, index) => (
            <div key={index} className="aspect-square bg-muted rounded-lg overflow-hidden">
              <Image 
                src={photo?.url} 
                alt={photo?.caption}
                className="w-full h-full object-cover hover:scale-105 transition-transform cursor-pointer"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OverviewTab;